import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PaymentComponent } from './payment.component';
import { PaymentService } from './payment.service';

import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        children: [
            { path: '', component: PaymentComponent }
        ]
    }
];

@NgModule({
  declarations: [PaymentComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes)
    
  ],
  exports: [RouterModule],
  providers:[PaymentService]
})
export class PaymentModule { }
